import SashiDo from 'lib/SashiDo';
import AccountManager from 'lib/AccountManager';
import moment from 'moment';
import history from 'dashboard/history';
import Button from 'components/Button/Button.react';
import FlowView from 'components/FlowView/FlowView.react';

import Field                    from 'components/Field/Field.react';
import Fieldset                 from 'components/Fieldset/Fieldset.react';
import FormButton               from 'components/FormButton/FormButton.react';
import FormModal                from 'components/FormModal/FormModal.react';
import FormTable                from 'components/FormTable/FormTable.react';
import KeyField                 from 'components/KeyField/KeyField.react';
import Label                    from 'components/Label/Label.react';
import Modal                    from 'components/Modal/Modal.react';
import React, { Component }     from 'react';
import PreLoader                from 'components/PreLoader/PreLoader.react';
import renderFlowFooterChanges  from 'lib/renderFlowFooterChanges';
import styles                   from 'dashboard/Settings/Settings.scss';
import settingsStyles           from 'dashboard/Settings/Settings.scss';
import TextInput                from 'components/TextInput/TextInput.react';
import Toolbar                  from 'components/Toolbar/Toolbar.react';
import { dateStringUTC }        from 'lib/DateUtils';
import UploadAvatarOrIcon       from 'components/UploadAvatarOrIcon/UploadAvatarOrIcon.react';
import Notification             from 'components/Notification/Notification.react';

export default class AccountSecurity extends Component {
  constructor(props) {
    super();

    this.state = {
      loading: false,
      note: null,
      user: {},
    };
  }

  renderForm({changes, fields, setField, resetFields}) {
    let { email, use_gravatar, image, name, createdAt } = this.props.currentUser;
    let { info } = this.props.currentCustomer;

    let securityFields =
      <Fieldset
        legend='Account Security'
        description='Update the personal information linked to this account.'>
        <div className={styles.settingsBox}>
          <Notification note={this.state.successMessage} close={true} />

          <div className={styles.info}>
            <Field
              label={<Label text='Current Password' />}
              input={<TextInput
                value={fields.currentPassword}
                hidden={true}
                onChange={setField.bind(this, 'currentPassword')} />} />

            <Field
              label={<Label text='New Password' />}
              input={<TextInput
                value={fields.newPassword}
                hidden={true}
                onChange={setField.bind(this, 'newPassword')} />} />

            <Field
              label={<Label text='Verify New Password' />}
              input={<TextInput
                value={fields.verifyPassword}
                hidden={true}
                onChange={setField.bind(this, 'verifyPassword')} />} />

          </div>
        </div>
      </Fieldset>

    let classes = [settingsStyles.settings_page, settingsStyles.default];

    return(
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={this.props.subsection} />
        <div className={[settingsStyles.holder, 'ShowFooter'].join(' ')}>
          <div className={styles.holder}>
            <PreLoader loading={this.state.loading}>
              {securityFields}
            </PreLoader>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let initialFields = {
      currentPassword: '',
      newPassword: '',
      verifyPassword: '',
    };

    return <FlowView
      initialFields={initialFields}
      footerContents={({ changes }) => renderFlowFooterChanges(changes, initialFields, pushFieldOptions)}
      onSubmit={({ changes, setField, resetFields }) => {
        const { currentPassword, newPassword, verifyPassword } = changes;

        return new Promise((resolve, reject) => {
          if(!currentPassword || currentPassword === '') {
            resetFields();
            return reject({ error: 'Missing current password!' });
          }

          if(!newPassword || newPassword === '') {
            return reject({ error: 'New Password field is empty' });
          }

          if(!verifyPassword || verifyPassword === '') {
            return reject({ error: 'Verify New Password field is empty' });
          }

          if(newPassword !== verifyPassword) {
            resetFields();
            return reject({ error: 'Passwords do not match!' });
          } else {
            resetFields();
            return SashiDo.changePassword({currentPassword, newPassword, email: this.props.currentUser.email }).then((data) =>{
              if(data.error_message) {
                return reject({ error: data.error_message })
              }

              this.setState({ successMessage: { type: 'info', message: 'Your password was changed successfully!' } });
              return resolve();
            });
          }
        });
      }}

      validate={({ changes }) => {
        if (!changes.currentPassword && !changes.newPassword && changes.verifyPassword) {
          return 'All fields are required';
        }
      }}
      renderForm={this.renderForm.bind(this)} />;
  }
}

let pushFieldOptions = {
  currentPassword: {
    friendlyName: 'current password',
    type: 'addition',
  },
  newPassword: {
    friendlyName: 'new password',
    type: 'addition',
  },
  verifyPassword: {
    friendlyName: 'confirm password',
    type: 'addition',
  },
}




